// extracted by mini-css-extract-plugin
export var breadcrumb = "breadcrumb-module--breadcrumb--1_OB_";
export var breadcrumb_link = "breadcrumb-module--breadcrumb_link--2XNdL";